// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__2AJNN","inputSingleColumnWrapper":"style_inputSingleColumnWrapper__1Z9vt","inputDoubleColumnWrapper":"style_inputDoubleColumnWrapper__HFZtD"};